import { render } from "./PushNotificationShowComponent.vue?vue&type=template&id=f38aa648"
import script from "./PushNotificationShowComponent.vue?vue&type=script&lang=js"
export * from "./PushNotificationShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/pushNotification/PushNotificationShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f38aa648"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f38aa648', __exports__)) {
    api.reload('f38aa648', __exports__)
  }
  
  module.hot.accept("./PushNotificationShowComponent.vue?vue&type=template&id=f38aa648", () => {
    api.rerender('f38aa648', render)
  })

}


export default __exports__